export const PASSWORD_SPECIALS = "!@#$%^&*()_+-=[]{}|;:,.<>?";

export type PasswordRule = {
  id: "length" | "upper" | "number" | "special";
  label: string;
  test: (pw: string) => boolean;
};

export const PASSWORD_RULES: PasswordRule[] = [
  { id: "length", label: "At least 8 characters", test: (p) => p.length >= 8 },
  { id: "upper", label: "At least one uppercase letter", test: (p) => /[A-Z]/.test(p) },
  { id: "number", label: "At least one number", test: (p) => /[0-9]/.test(p) },
  {
    id: "special",
    label: "At least one special character (!@#$%^&*()_+-=[]{}|;:,.<>?)",
    test: (p) => /[!@#$%^&*()_+\-=\[\]{}|;:,.<>?]/.test(p),
  },
];

export type StrengthTier = "empty" | "weak" | "fair" | "good" | "strong";

export function passwordStrength(pw: string): {
  tier: StrengthTier;
  score: number; // 0..4
  passedRules: Record<PasswordRule["id"], boolean>;
  allPassed: boolean;
} {
  const passedRules = Object.fromEntries(
    PASSWORD_RULES.map((r) => [r.id, r.test(pw)]),
  ) as Record<PasswordRule["id"], boolean>;
  const score = Object.values(passedRules).filter(Boolean).length;
  const allPassed = score === PASSWORD_RULES.length;
  let tier: StrengthTier = "empty";
  if (pw.length === 0) tier = "empty";
  else if (score <= 1) tier = "weak";
  else if (score === 2) tier = "fair";
  else if (score === 3) tier = "good";
  else tier = "strong";
  return { tier, score, passedRules, allPassed };
}

export const STRENGTH_META: Record<StrengthTier, { label: string; color: string; bar: string }> = {
  empty: { label: "", color: "text-muted-foreground", bar: "bg-border" },
  weak: { label: "Weak", color: "text-red-500", bar: "bg-red-500" },
  fair: { label: "Fair", color: "text-orange-500", bar: "bg-orange-500" },
  good: { label: "Good", color: "text-yellow-500", bar: "bg-yellow-500" },
  strong: { label: "Strong", color: "text-emerald-500", bar: "bg-emerald-500" },
};
